export class UserJournal {
    constructor(
      public user_journal_id: number,
      public user_id: number,
      public area: string,
      public notes: number,
      public created: string,
      public modified: string,
    ) {}
  }
